/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';
import { FilterMatchMode } from 'primeng/api';
import { DropdownFilterComponent } from './dropdown-filter.component';

export interface InputOptions {
  props?: {
    options: any[];
    value: string;
  };
  filterMatchMode?: string;
  filterChangeEvent?: EventEmitter<FilterMetadata>;
}

export const dropdownFilterFactory: FilterComponentFactory<DropdownFilterComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<DropdownFilterComponent>(DropdownFilterComponent).instance;
  },

  bindProps: (instance: DropdownFilterComponent, options?: InputOptions) => {
    instance.options = options?.props?.options ? options?.props?.options : [];
    instance.value = options?.props?.value ? options.props.value : null;
    instance.filterMatchMode = options?.filterMatchMode ? options?.filterMatchMode : FilterMatchMode.EQUALS;
  },

  subscribeToChanges: (instance: DropdownFilterComponent, options?: InputOptions) => {
    instance.filtersChange.subscribe((filterMetadata: FilterMetadata) => {
      if (options?.filterChangeEvent) {
        options.filterChangeEvent.emit(filterMetadata);
      }
    });
  },
};
